
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("9ewR5"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("9ewR5", function(module, exports) {

let $6b8ee8390e493747$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b8ee8390e493747$var$load("cRtGo"),
    $6b8ee8390e493747$var$load("3Zwna"),
    $6b8ee8390e493747$var$load("di1Y5"),
    $6b8ee8390e493747$var$load("aYECQ"),
    $6b8ee8390e493747$var$load("55OBD"),
    $6b8ee8390e493747$var$load("gfGrm"),
    $6b8ee8390e493747$var$load("24u6w"),
    $6b8ee8390e493747$var$load("27glK"),
    $6b8ee8390e493747$var$load("bvY53"),
    $6b8ee8390e493747$var$load("l8Ar8"),
    $6b8ee8390e493747$var$load("gFEtJ"),
    $6b8ee8390e493747$var$load("7jSfd"),
    $6b8ee8390e493747$var$load("4HZlX"),
    $6b8ee8390e493747$var$load("kDqHr"),
    $6b8ee8390e493747$var$load("gT8XU"),
    $6b8ee8390e493747$var$load("3GuOt"),
    $6b8ee8390e493747$var$load("3Mspc"),
    $6b8ee8390e493747$var$load("9aQIt"),
    $6b8ee8390e493747$var$load("XZauT"),
    $6b8ee8390e493747$var$load("4S1SF"),
    $6b8ee8390e493747$var$load("lm9Lt"),
    $6b8ee8390e493747$var$load("9wPDc"),
    $6b8ee8390e493747$var$load("1MWOL"),
    $6b8ee8390e493747$var$load("6fQco"),
    $6b8ee8390e493747$var$load("aOY32"),
    $6b8ee8390e493747$var$load("3MYQs"),
    $6b8ee8390e493747$var$load("6SWFK"),
    $6b8ee8390e493747$var$load("5zapo"),
    $6b8ee8390e493747$var$load("jiFtb"),
    $6b8ee8390e493747$var$load("9atVd"),
    $6b8ee8390e493747$var$load("iivLa"),
    $6b8ee8390e493747$var$load("6wr18"),
    $6b8ee8390e493747$var$load("dek7I"),
    $6b8ee8390e493747$var$load("6iz6l"),
    $6b8ee8390e493747$var$load("4SCW2"),
    $6b8ee8390e493747$var$load("fdKpi"),
    $6b8ee8390e493747$var$load("ffEVr"),
    $6b8ee8390e493747$var$load("hhss7"),
    $6b8ee8390e493747$var$load("l22f4"),
    $6b8ee8390e493747$var$load("eTYdV"),
    $6b8ee8390e493747$var$load("Wowvf"),
    $6b8ee8390e493747$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("kxO4K"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("kxO4K", function(module, exports) {

let $ef4dbbac423a979c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4dbbac423a979c$var$load("cRtGo"),
    $ef4dbbac423a979c$var$load("3Zwna"),
    $ef4dbbac423a979c$var$load("6wr18"),
    $ef4dbbac423a979c$var$load("3j4Bc"),
    $ef4dbbac423a979c$var$load("27glK"),
    $ef4dbbac423a979c$var$load("bvY53"),
    $ef4dbbac423a979c$var$load("ffEVr"),
    $ef4dbbac423a979c$var$load("fIjMV"),
    $ef4dbbac423a979c$var$load("psI7s"),
    $ef4dbbac423a979c$var$load("j3SHq"),
    $ef4dbbac423a979c$var$load("dfFoa"),
    $ef4dbbac423a979c$var$load("eTYdV"),
    $ef4dbbac423a979c$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("7POxG"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("7POxG", function(module, exports) {

let $5b4480784f1e10f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b4480784f1e10f0$var$load("1rQeu"),
    $5b4480784f1e10f0$var$load("h3ABO"),
    $5b4480784f1e10f0$var$load("2oPKP"),
    $5b4480784f1e10f0$var$load("gSg0R"),
    $5b4480784f1e10f0$var$load("4y0IB"),
    $5b4480784f1e10f0$var$load("iEUHW"),
    $5b4480784f1e10f0$var$load("kbwlB"),
    $5b4480784f1e10f0$var$load("2YffH"),
    $5b4480784f1e10f0$var$load("9XOeB"),
    $5b4480784f1e10f0$var$load("xu7ej"),
    $5b4480784f1e10f0$var$load("iQ4FP"),
    $5b4480784f1e10f0$var$load("5qTVP"),
    $5b4480784f1e10f0$var$load("cCWjv"),
    $5b4480784f1e10f0$var$load("7202t"),
    $5b4480784f1e10f0$var$load("9anPW"),
    $5b4480784f1e10f0$var$load("7VVIa"),
    $5b4480784f1e10f0$var$load("6wmiZ"),
    $5b4480784f1e10f0$var$load("im1VN"),
    $5b4480784f1e10f0$var$load("eD3Si"),
    $5b4480784f1e10f0$var$load("3BPqD"),
    $5b4480784f1e10f0$var$load("iGYnR"),
    $5b4480784f1e10f0$var$load("2SaXB"),
    $5b4480784f1e10f0$var$load("gnDXu"),
    $5b4480784f1e10f0$var$load("5XC9j"),
    $5b4480784f1e10f0$var$load("di1Y5"),
    $5b4480784f1e10f0$var$load("aYECQ"),
    $5b4480784f1e10f0$var$load("gfGrm"),
    $5b4480784f1e10f0$var$load("24u6w"),
    $5b4480784f1e10f0$var$load("l8Ar8"),
    $5b4480784f1e10f0$var$load("lTK3c"),
    $5b4480784f1e10f0$var$load("1WXdc"),
    $5b4480784f1e10f0$var$load("b2FtX"),
    $5b4480784f1e10f0$var$load("9AMyR"),
    $5b4480784f1e10f0$var$load("eKJoG"),
    $5b4480784f1e10f0$var$load("6iz6l"),
    $5b4480784f1e10f0$var$load("4SCW2"),
    $5b4480784f1e10f0$var$load("g6ldM"),
    $5b4480784f1e10f0$var$load("gf3H1"),
    $5b4480784f1e10f0$var$load("c0JsV"),
    $5b4480784f1e10f0$var$load("breTf"),
    $5b4480784f1e10f0$var$load("5bb7O"),
    $5b4480784f1e10f0$var$load("AJVgg"),
    $5b4480784f1e10f0$var$load("bJaqQ"),
    $5b4480784f1e10f0$var$load("cRtGo"),
    $5b4480784f1e10f0$var$load("6wr18"),
    $5b4480784f1e10f0$var$load("jvHRs"),
    $5b4480784f1e10f0$var$load("27glK"),
    $5b4480784f1e10f0$var$load("bvY53"),
    $5b4480784f1e10f0$var$load("5NQgH"),
    $5b4480784f1e10f0$var$load("hhss7"),
    $5b4480784f1e10f0$var$load("Wowvf"),
    $5b4480784f1e10f0$var$load("ffEVr"),
    $5b4480784f1e10f0$var$load("fIjMV"),
    $5b4480784f1e10f0$var$load("psI7s"),
    $5b4480784f1e10f0$var$load("j3SHq"),
    $5b4480784f1e10f0$var$load("dfFoa"),
    $5b4480784f1e10f0$var$load("jnVKv"),
    $5b4480784f1e10f0$var$load("3Zwna"),
    $5b4480784f1e10f0$var$load("7EorR"),
    $5b4480784f1e10f0$var$load("bgHzk"),
    $5b4480784f1e10f0$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.dee6847a.js.map
